//
//
//
//
//
//

import Slick from 'vue-slick';
import longArrowLeft from 'images/longArrowLeftWhite.png';
import longArrowRight from 'images/longArrowRightWhite.png';

export default {
  data: function() {
    return {
      images: [],
      slickOptions: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        prevArrow: `<button class="button button--prev">
         <img src="${longArrowLeft}" /> prev
        </button>`,
        nextArrow: `<button class="button button--next">
          next <img src="${longArrowRight}" />
        </button>`,
      },
    };
  },
  components: {
    Slick,
  },
};



// WEBPACK FOOTER //
// ./scripts/vue/project-image-carousel/ProjectImageCarousel.vue